import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import BottomTabNav from "../../customs/BottomTabNav"

import Input from "../../customs/Input";
export default function Plans(props) {
  const [inputPlans, setInputPlans] = useState([])
  const [isDelivery, setIsDelivery] = useState(false)
  const { profit_margins } = useSelector((state) => state.restaurant)

  const setProfitMargin = () => {
    typeof profit_margins !== "undefined" && setInputPlans(profit_margins)
  }

  useEffect(() => {
    setProfitMargin()
  }, [profit_margins])

  const onChangeCustomerPrice = (key, e) => {
    const { value } = e.target
    let plans = [...inputPlans]
    const profit_margin = plans[key].profit_margin
    const customer_price = (parseFloat(value) + parseFloat(profit_margin)).toFixed(2)
    plans[key].profit_margin = customer_price
    setInputPlans(plans)
  }

  return (
    <fieldset>
      <div className="ibox" category="Lunch">
        <div className="ibox-title">
          <h5>Lunch</h5>
        </div>
        <div className="ibox-content">
          <div className='d-flex justify-content-end'>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="isDelivery"
                onChange={() => setIsDelivery(!isDelivery)}
                checked={isDelivery} />
              <label className="form-check-label" htmlFor="isDelivery">
                Provide Delivery
              </label>
            </div>
          </div>
          {
            inputPlans.map((inputPlan, key) => (
              <div className='row' key={key}>
                <div className='col-sm-4 col-md-4'>
                  <Input
                    type="text"
                    label={inputPlan.plan_name}
                    name={inputPlan.plan_name}
                    required={true}
                    handler={(e) => onChangeCustomerPrice(key, e)}
                  />
                </div>
                <div className='col-sm-4 col-md-4'>
                  <Input
                    type="text"
                    label="Customer price"
                    name={inputPlan.plan_name}
                    required={true}
                    defaultValue={inputPlan.profit_margin}
                  />
                </div>
                <div className='col-sm-4 col-md-4'>
                  <Input
                    type="text"
                    label="Delivery price"
                    name={inputPlan.plan_name}
                    required={false}
                    disabled={!isDelivery}
                  />
                </div>
              </div>
            ))
          }
        </div>
      </div>
      <div className="ibox" category="Dinner">
        <div className="ibox-title">
          <h5>Dinner</h5>
        </div>
        <div className="ibox-content">
          <div className='d-flex justify-content-end'>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                onChange={() => setIsDelivery(!isDelivery)}
                checked={isDelivery} />
              <label className="form-check-label" htmlFor="isDelivery">
                Provide Delivery
              </label>
            </div>
          </div>
          {
            inputPlans.map((inputPlan, key) => (
              <div className='row' key={key}>
                <div className='col-sm-4 col-md-4'>
                  <Input
                    type="text"
                    label={inputPlan.plan_name}
                    name={inputPlan.plan_name}
                    required={true}
                    handler={(e) => onChangeCustomerPrice(key, e)}
                  />
                </div>
                <div className='col-sm-4 col-md-4'>
                  <Input
                    type="text"
                    label="Customer price"
                    name={inputPlan.plan_name}
                    required={true}
                    defaultValue={inputPlan.profit_margin}
                    disabled={true}
                  />
                </div>
                <div className='col-sm-4 col-md-4'>
                  <Input
                    type="text"
                    label="Delivery price"
                    name={inputPlan.plan_name}
                    required={false}
                    disabled={!isDelivery}
                  />
                </div>
              </div>
            ))
          }
        </div>
      </div>

      <BottomTabNav currentStep={4} props={props} />
    </fieldset>
  );
}
